import React from 'react';
import './FinePrint.css';
import { finePrintRenderer } from 'Utils/MarkdownRenderers';
import { Markdown } from 'Components/Markdown';

const withCTAText = (text, ctaText) => {
  return text.replace('___ctaText___', `"${ctaText}"`);
};

export const FinePrint = ({ text, className = '', linkClassName = '', ctaText = '' }) => {
  if (!text) return null;
  let finePrintText = text;
  if (ctaText) {
    finePrintText = withCTAText(finePrintText, ctaText);
  }
  const renderers = finePrintRenderer({ linkClassName, className });
  return <Markdown renderers={renderers}>{finePrintText}</Markdown>;
};
